import React from 'react';
import { Card as MuiCard, CardProps as MuiCardProps } from '@mui/material';
import { styled } from '@mui/material/styles';

// Custom Card component following Minimals.cc design
const StyledCard = styled(MuiCard, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant?: 'elevation' | 'outlined' }>(({ theme, variant = 'elevation' }) => ({
  position: 'relative',
  borderRadius: 16,
  transition: theme.transitions.create(['box-shadow', 'transform'], {
    duration: theme.transitions.duration.shorter,
  }),
  
  ...(variant === 'elevation' && {
    boxShadow: theme.shadows[1],
    '&:hover': {
      boxShadow: theme.shadows[4],
      transform: 'translateY(-2px)',
    },
  }),
  
  ...(variant === 'outlined' && {
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: theme.shadows[1],
      borderColor: theme.palette.grey[300],
    },
  }),
}));

interface CardProps extends Omit<MuiCardProps, 'variant'> {
  variant?: 'elevation' | 'outlined';
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ 
  variant = 'elevation', 
  children, 
  ...other 
}) => {
  return (
    <StyledCard variant={variant} {...other}>
      {children}
    </StyledCard>
  );
};

export default Card; 